import { createSlice } from '@reduxjs/toolkit';
import { ResponseApi } from '../BaseApi';
import {
    CreateExtraMeal,
    GetExtraOrders,
    GetFoodieUserMenuSelections,
    GetQr,
    GetStatusByUserIdActive,
    GetSummaryById,
    RetrievesAQrCodeBody,
    UpdateExtraOrders,
} from './FoodieExtraMealApi';
/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const FoodieExtraMealSlice = createSlice({
    name: 'extraMeal',
    initialState: {
        createMeal: null,
        updateMeal: null,
        extraOrdersActive: null,
        extraOrdersHistory: null,
        foodieUserMenuSelections: null,
        qrCode: null,
        summaryById:null,
        extraOrdersAdmin:null,
        statusByUserIdActive:null,
        qr:null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(CreateExtraMeal.fulfilled, (state, { payload }) => {
                state.createMeal = ResponseApi(payload);
            })
            .addCase(GetFoodieUserMenuSelections.fulfilled, (state, { payload }) => {
                state.foodieUserMenuSelections = ResponseApi(payload);
            })
            .addCase(RetrievesAQrCodeBody.fulfilled, (state, { payload }) => {
                state.qrCode = ResponseApi(payload);
            })
            .addCase(UpdateExtraOrders.fulfilled, (state, { payload }) => {
                state.updateMeal = ResponseApi(payload);
            })
            .addCase(GetSummaryById.fulfilled, (state, { payload }) => {
                state.summaryById = ResponseApi(payload);
            })
            .addCase(GetQr.fulfilled, (state, { payload }) => {
                state.qr = ResponseApi(payload);
            })
            .addCase(GetExtraOrders.fulfilled, (state, { payload }) => {
                state.extraOrdersAdmin = ResponseApi(payload);
            }).addCase(GetStatusByUserIdActive.fulfilled, (state, { payload }) => {
                state.statusByUserIdActive = ResponseApi(payload);
            })
    },
});

export const {} = FoodieExtraMealSlice.actions;

export default FoodieExtraMealSlice.reducer;
